'use client';

import { useEffect, useState } from 'react';
import { getPasskeyFlag } from './set-passkey-flag';

interface IPasskeyAvailability {
  isAvailable: boolean;
  isLoading: boolean;
}

export function usePasskeyAvailable(): IPasskeyAvailability {
  const [state, setState] = useState<IPasskeyAvailability>({
    isAvailable: false,
    isLoading: true,
  });

  useEffect(() => {
    const checkAvailability = async (): Promise<void> => {
      const hasPasskeyFlag = getPasskeyFlag();

      const isWebAuthnSupported =
        typeof window !== 'undefined' && window.PublicKeyCredential !== undefined;

      if (!isWebAuthnSupported) {
        setState({ isAvailable: false, isLoading: false });
        return;
      }

      setState({ isAvailable: hasPasskeyFlag, isLoading: false });
    };

    checkAvailability();
  }, []);

  return state;
}
